var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "uploadAdmissionPhotos" },
    [
      _c("div", { staticClass: "uploadAdmissionPhotos-box" }, [
        _c(
          "div",
          { staticClass: "cont" },
          [
            _c("Title", { attrs: { text: "入学照上传" } }),
            (_vm.info.enter_school_img ? true : false)
              ? _c("div", { staticClass: "info" }, [
                  _c("div", { staticClass: "item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("审核状态")]),
                    _c(
                      "span",
                      { staticClass: "value" },
                      [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm._f("isEnterSchoolImgCheckStyle")(
                                _vm.info.enter_school_img_check
                              ),
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm._f("isEnterSchoolImgCheckFilter")(
                                    _vm.info.enter_school_img_check
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]),
                  (_vm.info.check_remark ? true : false)
                    ? _c("div", { staticClass: "item" }, [
                        _c("span", { staticClass: "title" }, [
                          _vm._v("审核备注"),
                        ]),
                        _c("span", { staticClass: "value" }, [
                          _vm._v(_vm._s(_vm.info.check_remark)),
                        ]),
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "item" }, [
                    _c("span", { staticClass: "title" }, [_vm._v("入学照")]),
                    _c(
                      "span",
                      { staticClass: "value" },
                      [
                        _c("el-image", {
                          staticStyle: { height: "200px", width: "200px" },
                          attrs: {
                            src: _vm.info.enter_school_img,
                            fit: "contain",
                            "preview-src-list": [_vm.info.enter_school_img],
                          },
                        }),
                      ],
                      1
                    ),
                  ]),
                ])
              : _vm._e(),
            _vm.enterSchoolImgCheck == 0 ||
            _vm.info.enter_school_img_check == 0 ||
            _vm.info.enter_school_img_check == 3
              ? _c(
                  "div",
                  { staticClass: "upload" },
                  [
                    _c(
                      "el-upload",
                      {
                        staticClass: "upload-demo",
                        attrs: {
                          action: "",
                          "http-request": _vm.upLoadImg,
                          "show-file-list": false,
                        },
                      },
                      [
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("上传入学照"),
                        ]),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "tips" }, [
                      _vm._v("请上传蓝底的登记照"),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "el-button",
        {
          staticClass: "exit-btn",
          attrs: { type: "primary" },
          on: { click: _vm.exit },
        },
        [_vm._v("退出登录")]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }